<fof-messages-box *ngIf="contentId() === 'messages'" data-testid="messages-box"></fof-messages-box>
<div *ngIf="contentId() === 'personal-info'" class="overflow-y-auto h-100">
  <fof-personal-info data-testid="personal-info"></fof-personal-info>
</div>

<div *ngIf="contentId() === 'score-form'" class="h-100">
  <fof-score-form data-testid="score-form"></fof-score-form>
</div>
